import _Spin from "@arco-design/web-react/es/Spin";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import '@arco-design/web-react/dist/css/arco.css';
import { getAllConfig } from '@api/common';
import store from './redux';
import PreviewPage from './preview-page';
import Page from './page';
import initSlardar from '@src/utils/slardar';
import '@src/utils/tea';
import useAppContext from '@src/hooks/useAppContext';
import { GlobalContext } from '../context';
import './style/index.less';
initSlardar();
var TextAreaDom = document.querySelector('.projectData');
var values = TextAreaDom.value && JSON.parse(TextAreaDom.value);
window.__user__ = values.user;
window.__CssPreviewClassName = 'arco-color-block';
var showPreviewPage = location.pathname.indexOf("/themes/preview") > -1;
var PreviewApp = function PreviewApp() {
  var _a = useAppContext(),
    arcoLocale = _a.arcoLocale,
    contextValue = _a.contextValue;
  return /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store({
      token: {
        variables: {}
      },
      theme: {
        themeConfig: window.themeConfig
      },
      style: {
        savedStyles: values.savedStyles || {}
      }
    })
  }, /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: arcoLocale,
    loadingElement: /*#__PURE__*/React.createElement(_Spin, {
      size: 30
    })
  }, /*#__PURE__*/React.createElement(PreviewPage, null)))));
};
var PageApp = function PageApp(props) {
  var _a = useAppContext(),
    arcoLocale = _a.arcoLocale,
    contextValue = _a.contextValue;
  return /*#__PURE__*/React.createElement(Provider, {
    store: props.store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(BrowserRouter, {
    basename: "/themes/design/"
  }, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: arcoLocale,
    loadingElement: /*#__PURE__*/React.createElement(_Spin, {
      size: 30
    })
  }, /*#__PURE__*/React.createElement(Page, null)))));
};
if (showPreviewPage) {
  ReactDOM.render( /*#__PURE__*/React.createElement(PreviewApp, null), document.getElementById('root'));
} else {
  getAllConfig().then(function (result) {
    var tstore = store({
      token: {
        variables: result || {}
      },
      theme: {
        themeConfig: window.themeConfig
      },
      style: {
        savedStyles: values.savedStyles || {}
      }
    });
    ReactDOM.render( /*#__PURE__*/React.createElement(PageApp, {
      store: tstore,
      result: result
    }), document.getElementById('root'));
  })["catch"](function () {
    return location.href = '/themes/error';
  });
  ReactDOM.render( /*#__PURE__*/React.createElement(_Spin, {
    className: "align-loading"
  }), document.getElementById('root'));
}